import React, { Component } from 'react';
import { Link } from 'react-router';
import Header from '../components/Header.js';
import {
  getNotifications,
  patchNotifications,
  listSingleCase
} from '../utils/utils.js';
import { getSelectedTeamName } from '../common/globals';
import Bugsnag from '../helpers/bugsnag.js';
import withNotify from '../common/withNotify.js';
import withLoader from '../common/withLoader.js';
import OpenEnv from '../assets/images/open-env.svg';
import EmailOutline from '../assets/images/email-outline.svg';
import { targetPages } from '../helpers/firebase.js';
import withGoBack from '../common/withGoBack.js';
import withNotifications from '../common/withNotifications.js';
import { notificationsSet } from '../redux/actions.js';
import { store } from '../redux/store.js';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialNotifications: [],
      notifications: [],
      onlyShowUnread: false,
      notificationPage: 1,
      notificationSize: 50,
      moreNotifications: true,
      totalUnread: 0
    };
    this.lastNotificationRef = React.createRef();
    this.observer = React.createRef();
  }

  _getInitialNotifications = async () => {
    const { notify, setLoader } = this.props;
    const { notificationSize } = this.state;
    try {
      setLoader(true);
      const notificationsResponse = await getNotifications({
        page: 1,
        size: notificationSize
      });
      if (!notificationsResponse.status) {
        notify({ type: 'error', message: notificationsResponse.message });
        return;
      }
      this.setState({
        moreNotifications: notificationsResponse.notifications.length > 0,
        notificationPage: 1,
      }, () => {
        store.dispatch(notificationsSet({
          totalUnread: notificationsResponse.totalUnread,
          data: notificationsResponse.notifications
        }));
      });
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  _onNotificationRead = async (notificationId) => {
    const { setLoader, notifications } = this.props;
    setLoader(true);
    await patchNotifications(notificationId);
    setLoader(false);
    store.dispatch(notificationsSet({
      totalUnread: notifications.totalUnread - 1,
      data: notifications.data.map((notification) => {
        if (notification.id === notificationId) {
          return {
            ...notification,
            readAt: new Date()
          };
        }
        return notification;
      })
    }));
  }

  _onNotificationClick = async (notification) => {
    // console.log(notification);
    const { targetPage, targetCase } = notification;
    const { goBack, setGoBack, notify } = this.props;
    const targets = targetPages(targetCase);
    if (!targetPage) return;
    if (Object.keys(targets).includes(targetPage)) {
      if (notification.targetPage === 'CASE') {
        const teamName = await getSelectedTeamName();
        if (teamName !== notification.targetTeam.toUpperCase()) {
          notify({ type: 'error', message: `This notification is for ${notification.targetTeam.toUpperCase()}. Please change teams to view the case.` });
          return;
        }
        // If case is not in the db, fetch from remote
        const caseResFromRemote = await listSingleCase(notification.targetCase);
        if (!caseResFromRemote?.data?.length) {
          notify({ type: 'error', message: 'Case not found in currently active team.' });
          return;
        }
      }

      if (notification.readAt === null) {
        await this._onNotificationRead(notification.id);
      }
      if (targetPage === 'NOTIFICATIONS') return;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
      window.open(targets[targetPage], '_self');
    }
  }

  _onLoadMoreNotifications = async () => {
    const { notify, setLoader, notifications } = this.props;
    try {
      const { notificationPage, notificationSize } = this.state;
      setLoader(true);
      const notificationsResponse = await getNotifications({
        page: notificationPage + 1,
        size: notificationSize
      });
      if (!notificationsResponse.status) {
        notify({ type: 'error', message: notificationsResponse.message });
        setLoader(false);
        return;
      }
      this.setState({
        notificationPage: notificationPage + 1,
        moreNotifications: notificationsResponse.notifications.length > 0
      }, () => {
        store.dispatch(notificationsSet({
          totalUnread: notificationsResponse.totalUnread,
          data: notifications.data.concat(notificationsResponse.notifications)
        }));
      });
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  _onMarkAllRead = async () => {
    const { setLoader, notifications } = this.props;
    try {
      if (notifications.totalUnread === 0) return;
      setLoader(true);
      await patchNotifications();
      await this._getInitialNotifications();
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  _assignObserver = (node) => {
    const { observer } = this;
    const { moreNotifications } = this.state;
    if (this.observer.current) observer.current.disconnect();
    if (!moreNotifications) return;
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this._onLoadMoreNotifications();
        observer.current.disconnect();
      }
    });
    if (node) observer.current.observe(node);
  }

  _getUniqueNotifications = (notifications) => {
    const uniqueNotifications = [];
    notifications.forEach((notification) => {
      const index = uniqueNotifications
        .findIndex((uniqueNotification) => uniqueNotification.id === notification.id);
      if (index === -1) {
        uniqueNotifications.push(notification);
      }
    });
    return uniqueNotifications;
  }

  async UNSAFE_componentWillMount() {
    try {
      store.dispatch(notificationsSet({
        totalUnread: 0,
        data: []
      }));
      await this._getInitialNotifications();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      onlyShowUnread
    } = this.state;
    const {
      notifications
    } = this.props;

    return (
      <>
        <Header
          sideMenu
          title="Notifications"
        // actionButton={{
        //   onClick: () => this._onMarkAllRead(),
        //   title: 'Mark all as read',
        // }}
        />
        <section
          className="container pt-3"
        >
          {/* <section
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}
            className="mb-3"
          >
            <a
              role="button"
              tabIndex={0}
              className="unread-toggle cursor-pointer"
              onClick={() => this.setState({ onlyShowUnread: !onlyShowUnread })}
            >
              {onlyShowUnread ? 'Show all' : 'Show unread'}
            </a>
          </section> */}
          <section>
            <section style={{ display: 'flex', flexDirection: 'column' }}>
              {
                notifications.data?.length
                  ? (
                    this._getUniqueNotifications(notifications.data)
                      .filter(
                        (notification) => notification.readAt === null || !onlyShowUnread
                      ).map(
                        (notification) => (
                          <div
                            role="button"
                            tabIndex={0}
                            key={notification.id}
                            ref={this._assignObserver}
                            className={notification.targetPage
                              ? 'notification-card mb-3 cursor-pointer'
                              : 'notification-card mb-3'}
                            onClick={() => this._onNotificationClick(notification)}
                          >
                            <div
                              className="card-body"
                              style={{ cursor: ['NOTIFICATIONS', 'CALENDAR', 'CASE', 'BACKORDERS', 'SHIPMENTS', 'CONSIGNMENTS', 'REPORTS', 'MISSING_DGRS', 'MISSING_POS', 'UNBILLED'].includes(notification.targetPage) ? 'pointer' : 'default' }}
                            >
                              <h5 className={`card-title ${['NOTIFICATIONS', 'CALENDAR', 'CASE', 'BACKORDERS', 'SHIPMENTS', 'CONSIGNMENTS', 'REPORTS', 'MISSING_DGRS', 'MISSING_POS', 'UNBILLED'].includes(notification.targetPage) ? 'theme-color' : ''}`}>
                                {notification.title}
                              </h5>
                              <p className="card-text">
                                {notification.body}
                              </p>
                            </div>
                            {
                              notification.readAt === null ? (
                                <img
                                  src={EmailOutline}
                                  alt="env-outline"
                                  style={{ width: '25px', cursor: 'pointer' }}
                                />
                              ) : (
                                <img src={OpenEnv} alt="env-outline" style={{ width: '25px' }} />
                              )
                            }
                          </div>
                        )
                      )
                  ) : (
                    <p className="w-100 text-center">
                      There are no notifications to be displayed.
                    </p>
                  )
              }
            </section>
          </section>

          <div className="navbar-bottom height-48">
            <div className="footer-nav-container b-0 notification-bottom-bar">
              <div className="d-flex justify-content-between w-80" style={{ margin: '0 auto' }}>
                <Link onClick={() => this._onMarkAllRead()}>
                  <span>Mark all as read</span>
                </Link>
                <Link onClick={() => this.setState({ onlyShowUnread: !onlyShowUnread })}>
                  <span>{onlyShowUnread ? 'Show all' : 'Show unread'}</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withNotifications(
  withGoBack(
    withLoader(
      withNotify(
        Notifications
      )
    )
  )
);
